import _defineProperty from "@babel/runtime/helpers/defineProperty";
import nanoid from 'nanoid';
// eslint-disable-next-line flowtype/no-weak-types
export default class MessageQueue {
  constructor() {
    _defineProperty(this, "messages", []);

    _defineProperty(this, "subscriber", void 0);
  }

  emit(message) {
    this.messages.push({
      id: nanoid(),
      ...message
    });

    if (this.subscriber) {
      this.processQueue();
    }
  }

  setSubscriber(subscriber) {
    this.subscriber = subscriber;
    this.processQueue();
  }

  dequeueMessage(messageId) {
    this.messages = this.messages.filter(message => message.id !== messageId);
  }

  processQueue() {
    this.messages.forEach(message => {
      this.subscriber(message);
      this.dequeueMessage(message.id);
    });
  }

}